import React, { Fragment } from 'react';
import moment from 'moment';

import EquipmentProfile from './Profile';
import Instrument from '../../components/instrument/Instrument';

import {
  Box,
  Card,
  colors,
  Icon,
  Avatar,
  CardContent,
  CardHeader,
  Divider,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Button,
  makeStyles,
  Typography,
  DialogActions
} from '@material-ui/core';

import {
  Activity as ActivityIcon
} from 'react-feather';

import DWMM10 from '../panels/engetron/dwmm10';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  cardEvent: {
  }
}));

const Usage = ({ open, usageItem, closeUsage, openAcitivity, sendCommands, openHistory }) => {

  const classes = useStyles();

  const isOnline = (event, device) => {
    if (event && device) {
      var dt = moment(event.createdAt);
      var now = moment();
      var dur = moment.duration(now.diff(dt)).as("minutes");
      return (dur < ((device.frequency) ? device.frequency : 0) + ((device.timeOut) ? device.timeOut : 0));
    } else {
      return 0;
    }
  }

  return (
    <Fragment>

      <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" fullWidth>
        <DialogTitle id="form-dialog-title">
          <Typography
            color="textPrimary"
            variant="h4">
            Estado de Uso do Equipamento
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>


          <Grid
            container
          >
            <Grid
              item
              md={12}
              xs={12}
            >
              <Card className={classes.cardEvent}>

                {isOnline(usageItem.event, usageItem.device) ?
                  (<CardHeader
                    avatar={
                      <Avatar style={{ color: colors.blue[400], backgroundColor: colors.green[600] }}  >
                        <Icon component={ActivityIcon} style={{ color: 'white' }}  ></Icon>
                      </Avatar>
                    }
                    title={`Estado atualizado em ` + moment(usageItem.event.createdAt).format('DD/MM/YYYY')}
                    subheader={<b><b>{moment(usageItem.event.createdAt).format('HH:mm:ss')} </b> <b style={{ color: colors.green[600] }}> {`( DISPOSITIVO CONECTADO )`} </b></b>}
                  />)
                  :
                  (<CardHeader
                    avatar={
                      <Avatar style={{ color: colors.blue[400], backgroundColor: colors.red[600] }}  >
                        <Icon component={ActivityIcon} style={{ color: 'white' }}  ></Icon>
                      </Avatar>
                    }
                    title={`Estado atualizado em ` + moment(usageItem.event.createdAt).format('DD/MM/YYYY')}
                    subheader={<b><b>{moment(usageItem.event.createdAt).format('HH:mm:ss')} </b> <b style={{ color: colors.red[600] }}> {`( DISPOSITIVO DESCONECTADO )`} </b></b>}
                  />)
                }

                <Divider></Divider>

                <CardContent className={classes.abs}>


                  <Box alignItems="center"
                    display="flex"
                    flexDirection="column"
                  >
                    <Grid
                      container
                      direction="row"
                      justify="flex-start"
                      alignItems="stretch">

                      <Grid
                        item
                        ms={12}
                        lg={12}
                        xs={12}>

                        <EquipmentProfile
                          activation={usageItem.activation}
                          openAcitivity={openAcitivity}
                          openHistory={openHistory}
                        />

                      </Grid>



                      {(usageItem.panel.code == 'PANL01') ? (
                        <Grid
                          item
                          ms={12}
                          lg={12}
                          xs={12}>

                          <DWMM10
                            usageItem={usageItem}
                            sendCommands={sendCommands}
                          />

                        </Grid>

                      ) : (

                        <Fragment>
                          {(usageItem.panel.instruments.map(instrument => (

                            <Grid
                              item
                              ms={12}
                              lg={12}
                              xs={12}>

                              <Instrument
                                panel={usageItem.panel}
                                instrument={instrument}
                                message={usageItem.message}
                                event={usageItem.event}
                                alarm={usageItem.alarm}
                                device={usageItem.device}
                                schedules={usageItem.schedules}
                                commands={usageItem.commands}
                                sendCommands={sendCommands}
                              />

                            </Grid>

                          )))}

                        </Fragment>

                      )}
                    </Grid>
                  </Box>
                </CardContent>

              </Card>

            </Grid>

          </Grid>

        </DialogContent>

        <Divider />

        <DialogActions>
          <Grid container
            direction="row"
            justify="flex-end"
            alignItems="center">
            <Grid item >
              <Button
                color="secondary"
                size="small"
                variant="contained"
                onClick={() => { closeUsage() }}>
                Fechar
              </Button>
            </Grid>
          </Grid>
        </DialogActions>

      </Dialog>

    </Fragment>

  );
};

export default Usage;
